export enum PosValidationAction {
    Refund,
    Store,
    Update,
    UpdateHash,
    DiscountsStore,
}
